import { LanguageType } from '../app/store';

export const TRANSLATIONS: Record<LanguageType, Record<string, string>> = {
  vi: {
    app_title: 'Mộng Vân Nam',
    app_subtitle: 'Yunnan Dreamscape · 彩云之境',
    app_tagline: '3D Diorama & Âm nhạc thư giãn',
    loading_engine: 'Đang khởi tạo không gian',
    loading_ready: 'Sẵn sàng 100%',
    btn_start: 'Bắt đầu khám phá',
    loading_hint: 'Nhấn 1-6 để chọn góc nhìn. Kéo để khám phá, cuộn để phóng to.',

    // Scenes
    scene_yulong: 'Ngọc Long tuyết sơn',
    scene_lijiang: 'Lệ Giang cổ trấn',
    scene_erhai: 'Hồ Nhĩ Hải',

    // Camera Views - Yulong
    view_yulong_1: 'Toàn cảnh đồng cỏ',
    view_yulong_2: 'Cabin cáp treo',
    view_yulong_3: 'Bờ hồ Lam Nguyệt',
    view_yulong_4: 'Bay đỉnh tuyết',
    view_yulong_5: 'Đồng cỏ bò Yak',
    view_yulong_6: 'Bay tự do',

    // Camera Views - Lijiang
    view_lijiang_1: 'Toàn cảnh trên cao',
    view_lijiang_2: 'Dạo ngõ phố đá',
    view_lijiang_3: 'Cầu đá cổ',
    view_lijiang_4: 'Guồng nước lớn',
    view_lijiang_5: 'Vạn Cổ Lâu ngắm cảnh',
    view_lijiang_6: 'Bay tự do',

    // Camera Views - Erhai
    view_erhai_1: 'Toàn cảnh mặt hồ',
    view_erhai_2: 'Soi bóng Tam Tháp',
    view_erhai_3: 'Đường làng Bạch tộc',
    view_erhai_4: 'Thuyền thưởng ngoạn',
    view_erhai_5: 'Cánh chim hải âu',
    view_erhai_6: 'Lái thuyền',

    // Weather
    weather_sunny: 'Trời nắng dịu',
    weather_rain: 'Mưa phùn lãng đãng',
    weather_snow: 'Tuyết rơi lất phất',
    weather_restricted: 'Cảnh này không hỗ trợ tuyết',

    // Time of day
    time_dawn: 'Bình minh (Hồng hà)',
    time_morning: 'Buổi sáng (Nắng sớm)',
    time_noon: 'Buổi trưa (Nắng trong)',
    time_golden: 'Hoàng hôn vàng',
    time_dusk: 'Chiều tà (Đèn lồng lên)',
    time_night: 'Đêm trăng sao thanh tịnh',

    // UI & HUD
    hud_hide: 'Ẩn giao diện (H)',
    hud_show: 'Hiện giao diện (H)',
    hud_chill_mode: 'Thong thả',
    hud_photo_mode: 'Chụp ảnh',
    hud_shortcuts: 'Phím tắt',
    hud_settings: 'Cài đặt',
    hud_scene_picker: 'Chọn cảnh',

    // Audio
    audio_play: 'Phát nhạc',
    audio_pause: 'Tạm dừng',
    audio_next: 'Bài kế tiếp',
    audio_prev: 'Bài trước',
    audio_mute: 'Tắt tiếng',
    audio_unmute: 'Bật tiếng',
    audio_add_songs: 'Thêm nhạc từ máy',
    audio_add_songs_hint: 'Bài hát bạn chọn chỉ chạy trên thiết bị này, không tải lên mạng.',
    audio_sleep_timer: 'Hẹn giờ tắt nhạc',
    audio_sleep_off: 'Tắt hẹn giờ',
    audio_sleep_15: '15 phút',
    audio_sleep_30: '30 phút',
    audio_sleep_60: '60 phút',
    audio_generative_track: 'Giai điệu ngũ cung Mộng Vân Nam',
    audio_generative_artist: 'Web Audio Synthesizer',

    // Settings
    settings_title: 'Cài đặt trải nghiệm',
    settings_atmosphere: 'Bầu không khí',
    settings_time: 'Thời gian trong ngày',
    settings_weather: 'Thời tiết',
    settings_visuals: 'Đồ họa & Hiệu ứng',
    settings_quality: 'Chất lượng',
    settings_optimize: 'Tối ưu hiệu năng (cho máy yếu / điện thoại)',
    settings_tiltshift: 'Hiệu ứng thu nhỏ (Tilt-Shift)',
    settings_pixelart: 'Phong cách Pixel Art',
    settings_inklines: 'Đường viền mực thủy mặc (Ink Lines)',
    settings_bloom: 'Ánh sáng tỏa dịu (Bloom)',
    settings_reduce_motion: 'Giảm chuyển động (Reduce Motion)',
    settings_language: 'Ngôn ngữ (Language)',
    settings_reset: 'Khôi phục mặc định',
    settings_about_btn: 'Giới thiệu & Bản quyền',

    // Quality presets
    quality_low: 'Thấp',
    quality_medium: 'Vừa',
    quality_high: 'Cao',
    quality_auto: 'Tự động',

    // Shortcuts
    shortcuts_title: 'Bảng phím tắt',
    shortcuts_views: '1–6: Chọn góc nhìn theo cảnh',
    shortcuts_drag: 'Kéo chuột trái / 1 ngón: Xoay góc nhìn',
    shortcuts_right_drag: 'Kéo chuột phải / 2 ngón: Trượt góc nhìn (Pan)',
    shortcuts_scroll: 'Cuộn chuột / chụm ngón: Phóng to / Thu nhỏ',
    shortcuts_fly: 'W A S D / Q E: Bay tới, lui, trái, phải / xuống, lên (Giữ Shift để bay nhanh)',
    shortcuts_boat: 'Phím mũi tên / Cần gạt ảo: Lái thuyền (ở góc nhìn 6 hồ Nhĩ Hải)',
    shortcuts_time: 'T / Shift+T: Chuyển thời gian tới / lui',
    shortcuts_pause: 'Phím Space: Tạm dừng chuyển động cảnh',
    shortcuts_speed: 'X: Tốc độ thời gian 0x / 1x',
    shortcuts_hud: 'H: Ẩn / hiện giao diện (HUD)',
    shortcuts_pixel: 'P: Bật / tắt Pixel Art',
    shortcuts_ink: 'O: Bật / tắt viền tranh thủy mặc',
    shortcuts_photo: 'F: Chụp ảnh lưu về máy',
    shortcuts_audio_mute: 'M: Bật / tắt tiếng nhạc',
    shortcuts_audio_nav: 'N / B: Bài tiếp theo / Bài trước',
    shortcuts_scene_nav: '[ ]: Chuyển cảnh trước / sau',
    shortcuts_help: '?: Bật bảng phím tắt này',

    // About & Credits
    about_title: 'Giới thiệu & Bản quyền',
    about_stylized_notice: 'Tuyên bố nghệ thuật: Các cảnh 3D trong "Mộng Vân Nam" là các tác phẩm mô phỏng cách điệu (stylized low-poly diorama) lấy cảm hứng từ phong cảnh và văn hóa đặc sắc của tỉnh Vân Nam (Trung Quốc), không phải là ảnh chụp hay quét 3D thực tế.',
    about_respect: 'Dự án tôn vinh nét đẹp văn hóa truyền thống của các dân tộc Nạp Tây (Naxi), Bạch (Bai), Tạng (Tibetan), Hani và Di (Yi).',
    about_zero_cost: 'Dự án hoàn toàn miễn phí, mã nguồn mở, không quảng cáo, không thu thập dữ liệu người dùng và không tốn phí bản quyền.',
    about_credits_heading: 'Bản quyền & Tác giả',
    about_code_music: 'Toàn bộ mã nguồn, hình học 3D, shader và bộ tổng hợp nhạc ngũ cung Web Audio được xây dựng nguyên bản.',
    about_takedown: 'Nếu có bất kỳ thắc mắc hoặc yêu cầu gỡ bỏ bản quyền, xin vui lòng liên hệ: diplamtuan@gmail.com',

    // Toys
    toy_cloud_parted: 'Mây đã tản ra để đón ánh mặt trời!',
    toy_flags_rippled: 'Những lá cờ nguyện lung linh bay trong gió!',
    toy_yak_fed: 'Bò Yak thong thả thưởng thức cỏ tươi!',
    toy_lantern_released: 'Hoa đăng mang theo ước nguyện nhẹ trôi trên dòng nước...',
    toy_waterwheel_spun: 'Guồng nước cổ tích xoay tròn rì rào suối mát!',
    toy_gulls_fed: 'Đàn chim hải âu ríu rít sà xuống mặt hồ!',
  },
  en: {
    app_title: 'Yunnan Dreamscape',
    app_subtitle: 'Mộng Vân Nam · 彩云之境',
    app_tagline: 'Living 3D Diorama & Gentle Relaxing Soundscapes',
    loading_engine: 'Initializing Dreamscape',
    loading_ready: 'Ready 100%',
    btn_start: 'Begin Exploration',
    loading_hint: 'Press 1-6 to choose a view. Drag to look around, scroll to zoom.',

    scene_yulong: 'Jade Dragon Snow Mountain',
    scene_lijiang: 'Old Town of Lijiang',
    scene_erhai: 'Erhai Lake',

    view_yulong_1: 'Meadow Overview',
    view_yulong_2: 'Cable Car Cabin',
    view_yulong_3: 'Blue Moon Lake Shore',
    view_yulong_4: 'Glacier Summit Fly-by',
    view_yulong_5: 'Yak Pasture',
    view_yulong_6: 'Free Flight',

    view_lijiang_1: 'Aerial Overview',
    view_lijiang_2: 'Cobblestone Lane Walk',
    view_lijiang_3: 'Ancient Bridge',
    view_lijiang_4: 'Great Waterwheel',
    view_lijiang_5: 'Wanggu Tower Vista',
    view_lijiang_6: 'Free Flight',

    view_erhai_1: 'Lake Panorama',
    view_erhai_2: 'Three Pagodas Reflection',
    view_erhai_3: 'Bai Village Lane',
    view_erhai_4: 'Passenger Boat',
    view_erhai_5: 'Seagull Flight',
    view_erhai_6: 'Drive the Boat',

    weather_sunny: 'Gentle Sunshine',
    weather_rain: 'Misty Rain',
    weather_snow: 'Soft Snowflakes',
    weather_restricted: 'Snow is not supported in this scene',

    time_dawn: 'Dawn (Alpenglow)',
    time_morning: 'Morning (Crisp Sun)',
    time_noon: 'Noon (Clear Sky)',
    time_golden: 'Golden Hour',
    time_dusk: 'Dusk (Lanterns lit)',
    time_night: 'Serene Starry Night',

    hud_hide: 'Hide HUD (H)',
    hud_show: 'Show HUD (H)',
    hud_chill_mode: 'Chill Mode',
    hud_photo_mode: 'Photo Mode',
    hud_shortcuts: 'Shortcuts',
    hud_settings: 'Settings',
    hud_scene_picker: 'Select Scene',

    audio_play: 'Play Music',
    audio_pause: 'Pause Music',
    audio_next: 'Next Track',
    audio_prev: 'Previous Track',
    audio_mute: 'Mute',
    audio_unmute: 'Unmute',
    audio_add_songs: 'Add My Songs',
    audio_add_songs_hint: 'Songs you add stay on your device and are never uploaded.',
    audio_sleep_timer: 'Sleep Timer',
    audio_sleep_off: 'Off',
    audio_sleep_15: '15 min',
    audio_sleep_30: '30 min',
    audio_sleep_60: '60 min',
    audio_generative_track: 'Yunnan Dreamscape Pentatonic Theme',
    audio_generative_artist: 'Web Audio Synthesizer',

    settings_title: 'Experience Settings',
    settings_atmosphere: 'Atmosphere',
    settings_time: 'Time of Day',
    settings_weather: 'Weather',
    settings_visuals: 'Visuals & Effects',
    settings_quality: 'Graphics Quality',
    settings_optimize: 'Optimize Performance (Low-spec / Mobile)',
    settings_tiltshift: 'Tilt-Shift (Miniature Diorama)',
    settings_pixelart: 'Pixel Art Style',
    settings_inklines: 'Ink Painting Outlines (Sobel)',
    settings_bloom: 'Soft Bloom Lighting',
    settings_reduce_motion: 'Reduce Motion',
    settings_language: 'Language',
    settings_reset: 'Reset to Defaults',
    settings_about_btn: 'About & Credits',

    quality_low: 'Low',
    quality_medium: 'Medium',
    quality_high: 'High',
    quality_auto: 'Auto',

    shortcuts_title: 'Keyboard Shortcuts',
    shortcuts_views: '1–6: Select camera views',
    shortcuts_drag: 'Left-drag / 1-finger: Orbit view',
    shortcuts_right_drag: 'Right-drag / 2-finger: Pan view',
    shortcuts_scroll: 'Scroll / Pinch: Zoom to cursor',
    shortcuts_fly: 'W A S D / Q E: Fly forward, back, left, right / down, up (Shift for boost)',
    shortcuts_boat: 'Arrow keys / Virtual joystick: Steer boat (Erhai View 6)',
    shortcuts_time: 'T / Shift+T: Advance / Rewind time of day',
    shortcuts_pause: 'Space: Pause / resume world animation',
    shortcuts_speed: 'X: Toggle time scale 0x / 1x',
    shortcuts_hud: 'H: Show / hide HUD',
    shortcuts_pixel: 'P: Toggle Pixel Art',
    shortcuts_ink: 'O: Toggle Ink Lines',
    shortcuts_photo: 'F: Capture PNG photo',
    shortcuts_audio_mute: 'M: Mute / unmute music',
    shortcuts_audio_nav: 'N / B: Next / previous song',
    shortcuts_scene_nav: '[ ]: Previous / next scene',
    shortcuts_help: '?: Show this shortcuts guide',

    about_title: 'About & Credits',
    about_stylized_notice: 'Artistic Statement: The 3D scenes in "Yunnan Dreamscape" are stylized, low-poly diorama interpretations inspired by the scenery and architecture of Yunnan, China. They are not photogrammetry or real-world scans.',
    about_respect: 'Respectfully celebrating the heritage and architectural traditions of Naxi, Bai, Tibetan, Hani, and Yi cultures.',
    about_zero_cost: 'Built with zero cost, 100% open-source software, zero trackers, and zero commercial restrictions.',
    about_credits_heading: 'Credits & Assets',
    about_code_music: 'Original procedural geometry algorithms, shaders, and real-time Web Audio pentatonic engine.',
    about_takedown: 'For takedown inquiries or questions, contact: diplamtuan@gmail.com',

    toy_cloud_parted: 'Clouds parted to reveal the glowing sky!',
    toy_flags_rippled: 'Prayer flags flutter gently in the mountain breeze!',
    toy_yak_fed: 'The yak contentedly grazes on mountain grass!',
    toy_lantern_released: 'A glowing water lantern drifts peacefully down the canal...',
    toy_waterwheel_spun: 'The grand waterwheel turns with splashing water!',
    toy_gulls_fed: 'White seagulls glide gracefully over the calm lake!',
  },
  'zh-CN': {
    app_title: '彩云之境',
    app_subtitle: 'Mộng Vân Nam · Yunnan Dreamscape',
    app_tagline: '立体微缩景观 · 悠扬轻松音乐',
    loading_engine: '正在构建梦境世界',
    loading_ready: '准备就绪 100%',
    btn_start: '进入探索',
    loading_hint: '按 1-6 键选择视角。按住拖拽探索，滚轮缩放。',

    scene_yulong: '玉龙雪山',
    scene_lijiang: '丽江古城',
    scene_erhai: '洱海',

    view_yulong_1: '草甸全景',
    view_yulong_2: '索道缆车',
    view_yulong_3: '蓝月谷湖畔',
    view_yulong_4: '雪峰飞掠',
    view_yulong_5: '牦牛草场',
    view_yulong_6: '自由飞行',

    view_lijiang_1: '鸟瞰全城',
    view_lijiang_2: '石板古巷漫步',
    view_lijiang_3: '古石桥',
    view_lijiang_4: '大水车广场',
    view_lijiang_5: '望古楼远眺',
    view_lijiang_6: '自由飞行',

    view_erhai_1: '湖光全景',
    view_erhai_2: '三塔倒影',
    view_erhai_3: '白族村落街道',
    view_erhai_4: '乘船观光',
    view_erhai_5: '海鸥飞翔',
    view_erhai_6: '驾驶游船',

    weather_sunny: '晴朗微风',
    weather_rain: '烟雨朦胧',
    weather_snow: '轻柔飘雪',
    weather_restricted: '此场景不支持降雪',

    time_dawn: '黎明 (雪山朝霞)',
    time_morning: '清晨 (明媚晨曦)',
    time_noon: '正午 (晴空万里)',
    time_golden: '黄金时段 (金色夕阳)',
    time_dusk: '黄昏 (华灯初上)',
    time_night: '静谧星夜 (月影星河)',

    hud_hide: '隐藏界面 (H)',
    hud_show: '显示界面 (H)',
    hud_chill_mode: '漫游闲逛',
    hud_photo_mode: '拍照截图',
    hud_shortcuts: '快捷键',
    hud_settings: '设置',
    hud_scene_picker: '切换场景',

    audio_play: '播放音乐',
    audio_pause: '暂停音乐',
    audio_next: '下一首',
    audio_prev: '上一首',
    audio_mute: '静音',
    audio_unmute: '恢复声音',
    audio_add_songs: '导入本地音乐',
    audio_add_songs_hint: '您添加的音乐仅保存在本地设备，绝不会上传。',
    audio_sleep_timer: '睡眠定时器',
    audio_sleep_off: '关闭定时',
    audio_sleep_15: '15 分钟',
    audio_sleep_30: '30 分钟',
    audio_sleep_60: '60 分钟',
    audio_generative_track: '彩云之境五声音阶主题曲',
    audio_generative_artist: 'Web Audio 实时合成器',

    settings_title: '体验与效果设置',
    settings_atmosphere: '环境与天气',
    settings_time: '时间氛围',
    settings_weather: '天气',
    settings_visuals: '画面与特效',
    settings_quality: '画质设置',
    settings_optimize: '性能优化模式 (适配低配或手机)',
    settings_tiltshift: '移轴微缩透镜 (Tilt-Shift)',
    settings_pixelart: '复古像素风 (Pixel Art)',
    settings_inklines: '水墨线描边缘 (Ink Lines)',
    settings_bloom: '柔光辉光 (Bloom)',
    settings_reduce_motion: '减弱动态效果 (Reduce Motion)',
    settings_language: '语言 (Language)',
    settings_reset: '恢复默认设置',
    settings_about_btn: '关于与致谢',

    quality_low: '低',
    quality_medium: '中',
    quality_high: '高',
    quality_auto: '自动',

    shortcuts_title: '键盘快捷键指南',
    shortcuts_views: '1–6: 选择场景指定视角',
    shortcuts_drag: '左键拖拽 / 单指滑动: 旋转环顾',
    shortcuts_right_drag: '右键拖拽 / 双指滑动: 平移视角',
    shortcuts_scroll: '滚轮 / 双指捏合: 准心平滑缩放',
    shortcuts_fly: 'W A S D / Q E: 前后左右 / 上下飞行 (按住Shift加速)',
    shortcuts_boat: '方向键 / 虚拟摇杆: 操纵游船 (洱海视角6)',
    shortcuts_time: 'T / Shift+T: 顺时针 / 逆时针切换时间',
    shortcuts_pause: '空格键 Space: 暂停 / 恢复世界运动',
    shortcuts_speed: 'X: 切换时间流速 0x / 1x',
    shortcuts_hud: 'H: 显示 / 隐藏HUD界面',
    shortcuts_pixel: 'P: 开关像素风滤镜',
    shortcuts_ink: 'O: 开关水墨线描滤镜',
    shortcuts_photo: 'F: 拍照保存高清PNG截图',
    shortcuts_audio_mute: 'M: 开启 / 关闭静音',
    shortcuts_audio_nav: 'N / B: 下一曲 / 上一曲',
    shortcuts_scene_nav: '[ ]: 切换上一个 / 下一个场景',
    shortcuts_help: '?: 打开此快捷键面板',

    about_title: '关于与致谢',
    about_stylized_notice: '艺术声明：“彩云之境”中的3D场景为低多边形艺术风格微缩景观，灵感汲取自中国云南的秀美风光与民族聚落，并非真实世界的实景航拍或激光扫描。',
    about_respect: '向纳西族、白族、藏族、哈尼族、彝族等多元民族的灿烂文化与传统建筑致以诚挚敬意。',
    about_zero_cost: '本项目完全免费、开源、无广告、不收集用户隐私，且严格遵守版权法律规范。',
    about_credits_heading: '素材与致谢',
    about_code_music: '全部三维几何算法、渲染着色器与五声音阶实时合成器均为自主原创构建。',
    about_takedown: '版权声明或联系方式：diplamtuan@gmail.com',

    toy_cloud_parted: '云海散开，天光倾泻而下！',
    toy_flags_rippled: '祈福风马旗在山风中欢快飘扬！',
    toy_yak_fed: '可爱的牦牛正在悠闲地吃草！',
    toy_lantern_released: '许愿水灯随波逐流，载着祈愿远去...',
    toy_waterwheel_spun: '古老大水车欢快转动，水花飞溅！',
    toy_gulls_fed: '红嘴海鸥飞翔盘旋在碧蓝的湖面之上！',
  },
};

export function t(key: string, lang?: LanguageType): string {
  const currentLang = lang || (typeof window !== 'undefined' ? (window as unknown as { currentLang?: LanguageType }).currentLang || 'vi' : 'vi');
  return TRANSLATIONS[currentLang]?.[key] || TRANSLATIONS['vi']?.[key] || key;
}
